import request from '@/router/axios'
import env from '@/config/env'

// 分页
export function pageApi(params) {
  return request({
    url: env.officeUrl + '/asset-kind/v1/page',
    method: 'post',
    data: params
  })
}
// 资产分类树列表
export function treeList(params) {
  return request({
    url: env.officeUrl + '/asset-kind/v1/tree-list',
    method: 'get',
    params
  })
}
// 新增或编辑
export function assetSave(params) {
  return request({
    url: env.officeUrl + '/asset-kind/v1/save',
    method: 'post',
    data: params
  })
  // 新增或编辑
}
export function assetDelete(params) {
  return request({
    url: env.officeUrl + '/asset-kind/v1/delete/' + params,
    method: 'post'
  })
}
// 启用-停用
export function assetEnable(params) {
  return request({
    url: env.officeUrl + '/asset-kind/v1/enable',
    method: 'post',
    data: params
  })
}
